import { BoundView } from "./view";

export function Directive(): ClassDecorator {
  return (target: any) => {
    const skOnInit: any = target.prototype.skOnInit;
    target.prototype.skOnInit = function (...args): void {
      if (skOnInit) {
        skOnInit.apply(this, args);
      }
    };

    // const skAfterViewInit: any = target.prototype.skAfterViewInit;
    // target.prototype.skAfterViewInit = function(...args): void {
    //   // new BoundView(this.$skelem, this);
    //   if (skAfterViewInit) {
    //     skAfterViewInit.apply(this, args);
    //   }
    // };

    const skUpdateView: any = target.prototype.skUpdateView;
    target.prototype.skUpdateView = function (...args): void {
      new BoundView(this.$skelem, this);
      if (skUpdateView) {
        skUpdateView.apply(this, args);
      }
    };

    const skOnDestroy: any = target.prototype.skOnDestroy;
    target.prototype.skOnDestroy = function (...args): void {
      this.$$directive = {};
      if (skOnDestroy) {
        skOnDestroy.apply(this, args);
      }
    };
  };
}
